import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData } from '../Services/api';

const CategoryView = () => {
    const { id } = useParams();
    const [values, setValues] = useState({
        cat_name: "",
        description: "",
        cat_image: null,
        parentId: ""
    })
    const [parentCategories, setParentCategories] = useState([]);
    const fetchCategories = async () => {
        try {
            const res = await getData(`/category/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch categories", error)
        }
    }
    const loadParentCategories = async () => {
        try {
            const res = await getData("/category/parents");
            if (res.status) {
                setParentCategories(res.data);
            }
        } catch (error) {
            console.log("Error loading parent categories");
        }
    };

    useEffect(() => {
        loadParentCategories();
    }, []);
    useEffect(() => {
        fetchCategories();
    }, [id])



    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/categories/category-list">Category</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            View Category
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">View Category</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>View Category</h5>
                                </div>
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-sm-6 mb-3">
                                                <label htmlFor="cat_image" className="form-label">
                                                    Category Image
                                                </label><br />
                                                {values.cat_image && (
                                                    <img
                                                        src={values?.cat_image ? `${values.cat_image}` : avtar5}
                                                        alt="Preview"
                                                        className="img-fluid mt-2"
                                                        style={{ maxWidth: "150px", borderRadius: "8px" }}
                                                    />
                                                )}

                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Category Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Category Name"
                                                        name='cat_name'
                                                        value={values.cat_name}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            {/* PARENT CATEGORY */}
                                            <div className="col-md-12 mt-3">
                                                <label className="form-label">Select Parent Category (Optional)</label>
                                                <select
                                                    className="form-control"
                                                    name="parentId"
                                                    value={values.parentId}
                                                    disabled
                                                >
                                                    <option value="">-- No Parent (Top Category) --</option>

                                                    {parentCategories.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat.cat_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <div className="form-group">
                                                    <label className="form-label">Description</label>
                                                    <div className='border p-3 rounded' dangerouslySetInnerHTML={{ __html: values.description }} />
                                                </div>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CategoryView